import React from 'react'
import { constants } from 'common/helpers'
import cx from 'classnames'

import Box from 'components/_new/layout/Box/Box'
import Logo from 'components/ui/Logo/Logo'
import { Grid, Cell } from 'components/_new/layout/grid'
import { WidthContainer } from 'components/_new/layout/widthContainer'

import HamburgerButton from './HamburgerButton/HamburgerButton'
import LoginButton from './LoginButton/LoginButton'

import s from './Mobile.scss'


const Mobile = ({ isMale, logoLink, headerColor }) => (
  <div
    className={cx({
      [s[headerColor]]: headerColor,
    })}
  >
    <WidthContainer className={s.topNav} dataTestId={constants.testIds.layout.header}>
      <Grid className={s.topNavGrid} columns={4} alignItems="center">
        <Cell>
          <HamburgerButton />
        </Cell>
        <Cell size={2}>
          <Box alignCenter>
            <Logo dark={!isMale} light={isMale} redirect={logoLink} inlineSvg />
          </Box>
        </Cell>
        <Cell>
          <Box alignRight>
            <LoginButton />
          </Box>
        </Cell>
      </Grid>
    </WidthContainer>
  </div>
)


export default Mobile
